export interface Category {
  slug: string;
  name: string;
  en: string;
  desc: string;
  cover: string;
}

export interface Article {
  id: string;
  title: string;
  summary: string;
  category: string;
  cover: string;
  time: string;
  author: string;
  readTime: number;
  views: number;
  hot?: boolean;
  breaking?: boolean;
  tags: string[];
  content: string[];
}

export const categories: Category[] = [
  {
    slug: "yule",
    name: "娱乐",
    en: "Entertainment",
    desc: "影视、综艺、明星动态与娱乐圈最新爆料，第一时间掌握圈内新鲜事。",
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20red%20carpet%20glitter%20bokeh%20stage%20lights%20backstage%20atmosphere%2C%20cinematic%20warm%20amber%20and%20crimson%20color%20grading%2C%20glamorous%20editorial%20photography%2C%20soft%20focus%20depth%2C%20high%20detail%2C%20cohesive%20rich%20tonal%20quality&width=800&height=450&seq=cat-yule-2026&orientation=landscape",
  },
  {
    slug: "shehui",
    name: "社会",
    en: "Society",
    desc: "民生冷暖与热点事件追踪，理性记录正在发生的真实现场与话题。",
    cover:
      "https://readdy.ai/api/search-image?query=bustling%20chinese%20city%20street%20at%20dusk%20with%20warm%20streetlight%20glow%20and%20soft%20haze%2C%20candid%20documentary%20editorial%20photography%2C%20warm%20crimson%20and%20golden%20amber%20tones%2C%20natural%20lifelike%20scene%2C%20fine%20detail%2C%20cohesive%20tonal%20harmony&width=800&height=450&seq=cat-shehui-2026&orientation=landscape",
  },
  {
    slug: "caijing",
    name: "财经",
    en: "Finance",
    desc: "宏观与产业财经快讯，股票、楼市、消费趋势与公司动态一网打尽。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20financial%20data%20charts%20and%20rising%20graph%20lines%20over%20warm%20burgundy%20background%20with%20golden%20light%20particles%2C%20premium%20editorial%20finance%20photography%2C%20clean%20minimal%20composition%2C%20elegant%20professional%20tone%2C%20high%20detail&width=800&height=450&seq=cat-caijing-2026&orientation=landscape",
  },
  {
    slug: "keji",
    name: "科技",
    en: "Tech",
    desc: "前沿科技与新消费数码快讯，AI、手机、汽车与互联网创新动态。",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20minimal%20workspace%20with%20glowing%20smart%20device%20silhouettes%20and%20soft%20warm%20amber%20rim%20light%2C%20modern%20tech%20editorial%20photography%2C%20warm%20copper%20and%20gold%20tones%2C%20clean%20dark%20subtle%20background%2C%20high%20detail&width=800&height=450&seq=cat-keji-2026&orientation=landscape",
  },
  {
    slug: "tiyu",
    name: "体育",
    en: "Sports",
    desc: "赛场内外最新动态，赛事快讯、球星消息与运动热点时刻更新。",
    cover:
      "https://readdy.ai/api/search-image?query=dynamic%20sports%20stadium%20at%20night%20under%20bright%20floodlights%20with%20warm%20golden%20and%20crimson%20lighting%2C%20energetic%20editorial%20sports%20photography%2C%20motion%20and%20athletic%20energy%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=cat-tiyu-2026&orientation=landscape",
  },
];

export const articles: Article[] = [
  {
    id: "bl-2401",
    title: "独家：头部平台深夜调整创作分成机制，中小创作者格局或生变",
    summary:
      "多家内容平台被曝连夜更新分成规则，优质原创作者补贴力度加大，行业风向骤然改变，创作者圈层连夜讨论。",
    category: "keji",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20desk%20scene%20at%20night%20with%20multiple%20glowing%20screens%20showing%20live%20data%20and%20charts%2C%20warm%20crimson%20and%20golden%20ambient%20lighting%2C%20urgent%20editorial%20newsroom%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tonal%20quality&width=1200&height=700&seq=hero-breaking-2401&orientation=landscape",
    time: "刚刚",
    author: "爆报君",
    readTime: 4,
    views: 182300,
    breaking: true,
    hot: true,
    tags: ["内容平台", "创作者", "行业动态"],
    content: [
      "今日凌晨，多家头部内容平台同步上线新一轮创作分成规则，核心变化集中在原创优质内容的流量倾斜与作者补贴两个维度。有知情人士向每日爆料透露，新版规则将大幅提高长线原创内容的权重，同时对搬运与低质内容进行更严格的风控。",
      "多位头部创作者在接受采访时表示，新规对用心打磨作品的作者是明显利好，但也意味着行业竞争从拼数量转向拼质量。部分此前依靠批量转载起量的账号，或将面临流量明显下滑的压力。",
      "行业分析师指出，这一轮调整背后反映的是平台对内容生态可持续性的重新思考。随着补贴机制、推荐逻辑与结算节奏同步变化，中小创作者的营收结构可能在未来一个季度内出现重新洗牌。",
      "目前官方尚未就具体细则给出公开说明，相关讨论仍在创作者社区持续发酵。每日爆料将持续关注平台方的进一步回应，并在第一时间带来更新。",
    ],
  },
  {
    id: "bl-2302",
    title: "一档综艺首播即刷屏，素人真实表达为何成了今夏最大惊喜",
    summary:
      "一档以素人为核心的慢综艺开播后话题不断，没有流量嘉宾却靠真诚表达出圈，收视与口碑双丰收引发行业反思。",
    category: "yule",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20television%20studio%20stage%20with%20soft%20golden%20spotlights%20and%20gentle%20backstage%20glow%2C%20lively%20but%20intimate%20show%20set%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20tones%2C%20high%20detail%2C%20cohesive%20rich%20quality&width=800&height=450&seq=art-yule-2302&orientation=landscape",
    time: "12 分钟前",
    author: "文娱小报",
    readTime: 5,
    views: 96500,
    hot: true,
    tags: ["综艺", "素人节目", "收视"],
    content: [
      "没有顶流明星坐镇，一档聚焦普通年轻人真实生活的慢综艺却在首播当晚迅速刷屏，多条真实片段被网友反复转发，相关话题连续冲上热搜。",
      "节目组透露，之所以选择素人阵容，是希望回到内容本身，用不加修饰的表达去呈现生活的复杂与可爱。首期播出后，几位参与者的真诚发言打动了大量观众，也让行业重新审视“流量为王”的惯性思维。",
      "业内人士分析，观众的审美正在发生明显迁移，比起刻意的戏剧冲突，大家更愿意为真实、有温度的内容停留。节目后续能否持续输出，还需观察其叙事节奏与选题稳定性。",
    ],
  },
  {
    id: "bl-2303",
    title: "一线商圈夜间客流明显回暖，消费复苏呈现新信号",
    summary:
      "多地核心商圈夜间客流数据出炉，餐饮、文体与体验业态表现亮眼，观察人士认为消费信心正在温和修复。",
    category: "caijing",
    cover:
      "https://readdy.ai/api/search-image?query=busy%20shopping%20street%20mall%20at%20night%20with%20warm%20neon%20glow%20and%20crowds%20strolling%2C%20lively%20urban%20retail%20atmosphere%2C%20warm%20amber%20and%20soft%20crimson%20tones%2C%20editorial%20photography%2C%20high%20detail%2C%20cohesive%20warm%20quality&width=800&height=450&seq=art-caijing-2303&orientation=landscape",
    time: "38 分钟前",
    author: "财经观察",
    readTime: 4,
    views: 72300,
    tags: ["消费", "商圈", "复苏"],
    content: [
      "最新监测数据显示，多地核心商圈夜间时段客流较上月明显回升，其中餐饮、文体体验与亲子业态贡献了主要增量，商场营业时间延长成为普遍现象。",
      "有商圈运营负责人表示，夜间消费的恢复不仅体现在人数上，客单价与停留时长也同步改善，说明消费者正在从“逛一逛”转向更实质的体验消费。",
      "分析人士提醒，消费复苏的整体趋势仍需更多月份的零售数据确认，不同城市与业态之间也存在明显分化，不宜简单以单月数据下结论。",
    ],
  },
  {
    id: "bl-2304",
    title: "暴雨过后这座小城的水位牵动全网，多方驰援仍在继续",
    summary:
      "连日强降雨致多地内涝，救援力量昼夜坚守，社会爱心物资持续抵达，现场最新进展正在滚动更新。",
    category: "shehui",
    cover:
      "https://readdy.ai/api/search-image?query=rescue%20workers%20in%20orange%20vests%20assisting%20in%20rainy%20flooded%20area%20with%20warm%20emergency%20lights%20and%20soft%20dawn%20light%2C%20documentary%20humanitarian%20editorial%20photography%2C%20restrained%20warm%20tones%2C%20respectful%20high%20detail&width=800&height=450&seq=art-shehui-2304&orientation=landscape",
    time: "1 小时前",
    author: "现场直击",
    readTime: 6,
    views: 121800,
    hot: true,
    breaking: true,
    tags: ["气象", "救援", "现场"],
    content: [
      "连日强降雨导致南方部分地区出现内涝，当地迅速启动应急响应，救援队伍连夜转移被困群众。截至发稿，多条主干道积水已明显下降，供电、通信恢复工作正加速推进。",
      "多个社会组织与爱心企业自发筹集物资，第一批饮用水、食品与应急照明设备已运抵临时安置点。志愿者表示，大家最关心的是独居老人与儿童群体的安置情况。",
      "气象部门提示，未来数日仍存在短时强降水可能，请周边居民关注预警信息，尽量远离低洼地带，配合现场指引有序避险。每日爆料将持续跟进并更新最新现场动态。",
    ],
  },
  {
    id: "bl-2305",
    title: "篮球总决赛惊天逆转夺冠，最后时刻压哨绝杀引爆全场",
    summary:
      "一场充满悬念的巅峰对决，主队在最后数秒完成压哨绝杀逆转取胜，现场欢呼震天，更衣室庆祝画面刷屏网络。",
    category: "tiyu",
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20player%20celebrating%20a%20game%20winning%20shot%20in%20front%20of%20a%20packed%20arena%20with%20warm%20golden%20spotlights%20and%20confetti%2C%20thrilling%20championship%20moment%2C%20editorial%20sports%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-tiyu-2305&orientation=landscape",
    time: "2 小时前",
    author: "赛场快报",
    readTime: 4,
    views: 153200,
    hot: true,
    tags: ["篮球", "总决赛", "绝杀"],
    content: [
      "篮球总决赛第五场今日上演史诗级对决，客队前三节一度领先两位数，主队却在末节顽强追分，并在最后读秒阶段由核心后卫命中压哨三分完成反超绝杀。",
      "终场哨响瞬间，主场球迷陷入沸腾，多位球员泪洒赛场。赛后更衣室狂欢画面与绝杀瞬间的短视频在社交平台迅速传播，阅读量短时间突破千万。",
      "教练组在发布会上表示，球队赢在最后一刻都没有放弃，用防守和信念拼下了这座奖杯。接下来球队将进入调整期，为新的赛季做准备。",
    ],
  },
  {
    id: "bl-2306",
    title: "多地博物馆夜间开放热度攀升，“看展式”夏夜成为新潮流",
    summary:
      "从文创市集到沉浸式夜游，博物馆延长开放时间后吸引大批年轻观众，传统文化以更轻盈的姿态走进大众生活。",
    category: "shehui",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20museum%20interior%20at%20night%20with%20warm%20spotlight%20on%20ancient%20artifacts%20and%20visitors%20admiring%20quietly%2C%20warm%20golden%20exhibition%20lighting%2C%20cultural%20editorial%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-shehui-2306&orientation=landscape",
    time: "3 小时前",
    author: "文化速递",
    readTime: 4,
    views: 58200,
    tags: ["文博", "夜游", "文化消费"],
    content: [
      "入夏以来，多地博物馆陆续推出夜间开放与延时服务，配合文创市集、专家导览与沉浸式演出，让“晚上去逛博物馆”成为年轻人的新选择。",
      "据馆方统计，夜场开放以来预约人数持续攀升，且以 20 至 35 岁观众为主。不少观众表示，夜晚的展厅更安静，也更有沉浸感，是了解历史的另一种打开方式。",
      "专家认为，博物馆延长开放不仅拉动了文化消费，也重新定义了城市公共文化空间的活力。如何平衡参观体验与文物保护，仍是运营方持续探索的课题。",
    ],
  },
  {
    id: "bl-2307",
    title: "国产大模型密集发布新版本，推理能力成厂商比拼焦点",
    summary:
      "多家厂商竞相发布新一代大模型，在长文本理解、推理准确率与端侧部署上展开较量，行业进入能力深耕阶段。",
    category: "keji",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20neural%20network%20visualization%20with%20glowing%20golden%20nodes%20and%20warm%20copper%20light%20over%20dark%20background%2C%20futuristic%20ai%20editorial%20photography%2C%20clean%20minimal%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-keji-2307&orientation=landscape",
    time: "4 小时前",
    author: "科技锐评",
    readTime: 5,
    views: 88700,
    tags: ["大模型", "AI", "技术前沿"],
    content: [
      "本周多家国产 AI 厂商接连发布新一代大模型版本，主打更强的复杂推理与多模态理解能力，部分模型同步开放了端侧轻量版本，方便在手机等设备上离线运行。",
      "从各家公布的评测数据看，推理准确率与长文档处理能力成为本轮竞争的核心指标，这意味着行业正从“拼参数”转向“拼实用价值”。",
      "开发者社区普遍认为，模型的落地场景正变得越来越具体，金融、教育、办公等垂直行业成为各家争夺的主战场。价格与调用成本的下降，也让中小企业有了更多尝鲜空间。",
    ],
  },
  {
    id: "bl-2308",
    title: "热门 IP 舞台剧全国巡演官宣，首站一票难求",
    summary:
      "改编自现象级影视 IP 的舞台剧正式开启全国巡演，首站开票即售罄，主创团队透露将融入本地化惊喜桥段。",
    category: "yule",
    cover:
      "https://readdy.ai/api/search-image?query=theatrical%20stage%20curtains%20and%20warm%20spotlight%20glow%20on%20an%20empty%20grand%20stage%2C%20anticipation%20before%20a%20show%2C%20warm%20crimson%20and%20gold%20dramatic%20lighting%2C%20editorial%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-yule-2308&orientation=landscape",
    time: "5 小时前",
    author: "文娱小报",
    readTime: 3,
    views: 44200,
    tags: ["舞台剧", "IP", "巡演"],
    content: [
      "由人气影视 IP 改编的同名舞台剧今日官宣开启全国巡演，首站定于下月落地大型剧院。消息公布后，首场演出门票短时间内即告售罄，部分粉丝遗憾未能抢到。",
      "主创团队在发布会上透露，本轮巡演将根据每座城市的特色融入少量本地化彩蛋，同时升级了舞美与灯光设计，力求给观众带来不同于影视作品的沉浸体验。",
      "业内人士指出，优质 IP 向舞台剧延伸正成为行业趋势，但改编的成败关键在于能否讲好一个适合剧场表达的故事，而不只是堆砌经典桥段。",
    ],
  },
  {
    id: "bl-2309",
    title: "平价咖啡品牌加速下沉，小镇青年成新一轮消费主力",
    summary:
      "一杯几元到十几元的咖啡正在涌向更多县城与乡镇，品牌通过门店扩张与价格策略争夺下沉市场增量。",
    category: "caijing",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimalist%20coffee%20shop%20counter%20with%20freshly%20brewed%20coffee%20and%20soft%20golden%20morning%20light%2C%20cozy%20franchise%20store%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20high%20detail%2C%20cohesive%20warm%20quality&width=800&height=450&seq=art-caijing-2309&orientation=landscape",
    time: "6 小时前",
    author: "财经观察",
    readTime: 4,
    views: 61800,
    tags: ["咖啡", "下沉市场", "消费趋势"],
    content: [
      "平价咖啡品牌正加快向县城与乡镇扩张的步伐，多家品牌宣布今年将在下沉市场新开数百家门店，单杯价格普遍控制在十元上下的亲民区间。",
      "当地消费者表示，过去想喝一杯现磨咖啡往往要专程去市区，如今家门口就能买到，价格和口味也容易被接受。小镇青年正在成为带动新一轮咖啡消费的主力人群。",
      "券商分析指出，下沉市场的咖啡渗透率仍处于低位，想象空间可观，但品牌需要在供应链、选址与品控上同步下功夫，才能真正把规模优势转化为盈利。",
    ],
  },
  {
    id: "bl-2310",
    title: "城市骑行热持续升温，夜骑路线成社交新宠",
    summary:
      "越来越多年轻人加入骑行队伍，城市绿道与夜景路线人气高涨，骑行装备与赛事活动也随之迎来快速增长。",
    category: "shehui",
    cover:
      "https://readdy.ai/api/search-image?query=group%20of%20cyclists%20riding%20along%20a%20scenic%20riverfront%20bike%20path%20at%20golden%20hour%20with%20warm%20city%20skyline%20glow%2C%20active%20healthy%20lifestyle%2C%20editorial%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-shehui-2310&orientation=landscape",
    time: "7 小时前",
    author: "生活志",
    readTime: 3,
    views: 39100,
    tags: ["骑行", "生活方式", "城市"],
    content: [
      "天气转暖后，城市骑行热度持续走高，不少人在社交平台分享自己的骑行路线与夜骑片段，绿道与滨江景观路成为人气最高的选择。",
      "有骑行社群负责人介绍，参加夜骑的以年轻上班族为主，大家把它当作解压与社交的结合方式。专业一点的爱好者则会研究路书、升级装备、报名业余赛事。",
      "交通与市政部门也提醒，骑行热情值得鼓励，但请务必佩戴头盔、遵守交规，尽量选择光线充足的规范路线，安全永远是第一位。",
    ],
  },
  {
    id: "bl-2311",
    title: "新生代球员亚洲赛场亮眼表现引关注，主帅点名称赞潜力",
    summary:
      "在近期的亚洲赛事中，多名年轻球员表现抢眼，球队主帅赛后点名表扬，认为这批新人是球队未来的重要拼图。",
    category: "tiyu",
    cover:
      "https://readdy.ai/api/search-image?query=young%20footballer%20dribbling%20the%20ball%20under%20bright%20stadium%20lights%20with%20warm%20golden%20flare%20and%20grass%20texture%2C%20dynamic%20sports%20editorial%20photography%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-tiyu-2311&orientation=landscape",
    time: "9 小时前",
    author: "赛场快报",
    readTime: 3,
    views: 47600,
    tags: ["足球", "青年队", "亚洲赛事"],
    content: [
      "在近期的亚洲赛场比赛中，球队多名年轻球员贡献了关键发挥，其中一名 20 岁小将更是在边路多次制造威胁，成为全场最大亮点。",
      "主帅在赛后发布会上点名表扬了这批新人，称他们“训练投入、敢打敢拼，是球队未来几年最重要的拼图”。他同时提醒，年轻球员的成长需要耐心，要给足比赛机会。",
      "球迷群体对新生力量的涌现普遍感到振奋，认为球队正处在良性换血的关键阶段，希望俱乐部继续坚持青训投入，为下一代打好基础。",
    ],
  },
  {
    id: "bl-2312",
    title: "新能源车以旧换新细则落地，置换补贴成购车新焦点",
    summary:
      "新一轮汽车以旧换新政策细则正式公布，新能源车置换补贴与报废更新补贴同步上调，拉动效应初步显现。",
    category: "caijing",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20electric%20vehicle%20charging%20at%20a%20clean%20station%20with%20warm%20golden%20sunset%20light%20and%20soft%20bokeh%2C%20automotive%20editorial%20photography%2C%20warm%20amber%20and%20copper%20tones%2C%20high%20detail%2C%20cohesive%20warm%20quality&width=800&height=450&seq=art-caijing-2312&orientation=landscape",
    time: "12 小时前",
    author: "产业前线",
    readTime: 5,
    views: 93700,
    hot: true,
    tags: ["新能源", "以旧换新", "补贴"],
    content: [
      "新一轮汽车以旧换新政策实施细则今日正式落地，新能源车置换补贴上限有所提高，报废旧车后再购新车的消费者还能叠加额外补贴，政策拉动效应正逐步显现。",
      "多家品牌门店反馈，细则公布后咨询量与试驾量明显上升，尤其是面向通勤族的紧凑型新能源车型最受关注。销售人员建议消费者留意本地配套的消费券与促销叠加。",
      "分析人士认为，在价格战与政策红利共同作用下，下半年新能源车销量有望进一步走强，产业链上下游也将随之受益。后续仍须关注补贴资金使用的规范性与市场真实需求的匹配度。",
    ],
  },
  {
    id: "bl-2313",
    title: "悬疑剧热度登顶引热议：口碑佳作为何总藏在长尾片单里",
    summary:
      "一部低调上线的悬疑剧凭借扎实剧本口碑发酵，收视率一路走高，也再次引发关于“好剧如何被看见”的讨论。",
    category: "yule",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20dark%20detective%20room%20lit%20by%20a%20single%20warm%20desk%20lamp%20with%20case%20files%20and%20soft%20smoke%20in%20the%20air%2C%20suspenseful%20thriller%20editorial%20photography%2C%20warm%20amber%20chiaroscuro%2C%20high%20detail&width=800&height=450&seq=art-yule-2313&orientation=landscape",
    time: "14 小时前",
    author: "文娱小报",
    readTime: 4,
    views: 66900,
    tags: ["悬疑剧", "口碑", "推荐算法"],
    content: [
      "没有密集的宣发排片，一部低调上线的悬疑短剧却凭借扎实的剧本与表演迅速口碑发酵，播放热度在数日内登顶各大榜单，成为今年剧集市场的一匹黑马。",
      "观众普遍称赞其环环相扣的叙事与克制的高级质感。不少网友调侃，好剧常常“藏在推荐页面的长尾里”，全靠自来水安利才被看见。",
      "行业观察认为，越来越多精良的中小成本作品开始依靠口碑突围，这提醒平台与创作者：宣发很重要，但内容本身的说服力，才是一部作品能否走得更远的真正关键。",
    ],
  },
  {
    id: "bl-2314",
    title: "职场年轻人流行“数字排毒”，下班断联成为新选择",
    summary:
      "越来越多上班族尝试下班后关闭工作消息、减少刷屏时间，用运动与阅读重新夺回生活节奏，引发广泛共鸣。",
    category: "shehui",
    cover:
      "https://readdy.ai/api/search-image?query=relaxed%20young%20person%20reading%20a%20book%20in%20a%20warm%20cozy%20corner%20by%20a%20window%20with%20soft%20golden%20evening%20light%2C%20calm%20mindful%20lifestyle%2C%20editorial%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20cohesive%20warm%20quality&width=800&height=450&seq=art-shehui-2314&orientation=landscape",
    time: "16 小时前",
    author: "生活志",
    readTime: 4,
    views: 51800,
    tags: ["职场", "生活方式", "心理健康"],
    content: [
      "不少职场年轻人开始主动实践“数字排毒”：下班后关闭工作群提醒、设定固定的无屏幕时段，把时间还给运动、阅读与家人朋友。相关话题在社交平台引发大量共鸣。",
      "有受访者表示，最初戒断消息焦虑并不容易，但坚持几周后睡眠与专注力都有了明显改善，也重新找回对生活的掌控感。",
      "心理专家提醒，“数字排毒”不必追求绝对，关键是建立健康的使用边界。适度的离线时间能帮助大脑恢复，但也要避免因焦虑反弹而产生新的心理负担。",
    ],
  },
  {
    id: "bl-2315",
    title: "折叠屏手机销量倍增，轻薄与铰链技术成新卖点",
    summary:
      "折叠屏手机市场快速升温，多家厂商推出更轻薄的新品，铰链寿命与折痕控制成为消费者选购时的核心关注点。",
    category: "keji",
    cover:
      "https://readdy.ai/api/search-image?query=sleek%20foldable%20smartphone%20half%20open%20on%20a%20clean%20desk%20with%20warm%20studio%20lighting%20and%20soft%20golden%20reflections%2C%20premium%20product%20photography%2C%20minimal%20background%2C%20high%20detail%2C%20cohesive%20warm%20tone&width=800&height=450&seq=art-keji-2315&orientation=landscape",
    time: "18 小时前",
    author: "科技锐评",
    readTime: 4,
    views: 54900,
    tags: ["折叠屏", "手机", "数码"],
    content: [
      "随着价格门槛下探与工艺成熟，折叠屏手机销量迎来明显增长，已成为多家厂商高端产品线的主力出货方向。",
      "从近期发布的新品看，“更轻薄”成为各家比拼的重点，同时铰链的耐用性与屏幕折痕的改善也直接影响消费者的购买决策。线下门店里，不少用户在反复开合体验后才决定下单。",
      "分析人士预计，随着供应链进一步成熟，折叠屏有望在未来两年加速普及，但系统层面的多任务适配与维修成本仍是需要补齐的短板。",
    ],
  },
];

export const hotSearch: { rank: number; keyword: string; tag: string; count: string }[] = [
  { rank: 1, keyword: "总决赛压哨绝杀", tag: "爆", count: "2831 万热度" },
  { rank: 2, keyword: "平台分成新规", tag: "新", count: "2412 万热度" },
  { rank: 3, keyword: "素人综艺出圈", tag: "热", count: "1987 万热度" },
  { rank: 4, keyword: "以旧换新细则", tag: "新", count: "1765 万热度" },
  { rank: 5, keyword: "暴雨救援进行时", tag: "爆", count: "1590 万热度" },
  { rank: 6, keyword: "折叠屏轻薄之战", tag: "荐", count: "1283 万热度" },
  { rank: 7, keyword: "博物馆夜游", tag: "趣", count: "1087 万热度" },
  { rank: 8, keyword: "国产大模型新版", tag: "新", count: "0964 万热度" },
];

export const flashes: { time: string; tag: string; text: string }[] = [
  { time: "09:42", tag: "科技", text: "平台方就新分成细则作出初步回应，称将公开细则并听取作者建议。" },
  { time: "09:28", tag: "财经", text: "多家券商上调新能源车产业链盈利预测，板块午后走强。" },
  { time: "09:15", tag: "体育", text: "篮球总决赛 MVP 名单公布，压哨绝杀功臣荣誉当选。" },
  { time: "08:56", tag: "社会", text: "受强降水影响多条列车临时停运，铁路部门启动应急预案。" },
  { time: "08:31", tag: "娱乐", text: "舞台剧巡演加开场次，第二站开票时间提前公布。" },
  { time: "08:07", tag: "社会", text: "博物馆夜场预约入口正式开放，周末档期快速约满。" },
  { time: "07:49", tag: "科技", text: "国产大模型开放端侧版本，开发者可离线调用。" },
  { time: "07:22", tag: "财经", text: "平价咖啡品牌公布下半年下沉扩张计划，门店数再上台阶。" },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((a) => a.id === id);

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);

export const getArticlesByCategory = (slug: string): Article[] =>
  articles.filter((a) => a.category === slug);

export const getFeaturedArticles = (): Article[] =>
  articles.filter((a) => a.hot).slice(0, 5);

export const getRelatedArticles = (article: Article, limit = 4): Article[] =>
  articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .concat(articles.filter((a) => a.category !== article.category && a.id !== article.id))
    .slice(0, limit);